module.exports = __webpack_public_path__ + "static/media/mycoach-backarrow.8c3e9705.svg";